export default "__VITE_ASSET__nXiwktpr__"